/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Organizations {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description List organizations.
   *
   * @tags Organizations
   * @name ListOrganizations
   * @summary List Organizations
   * @request GET:/api/organizations
   * @secure
   */
  listOrganizations = (params = {}) =>
    this.http.request({
      path: `/api/organizations`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new organization.
   *
   * @tags Organizations
   * @name CreateOrganization
   * @summary Create Organization
   * @request POST:/api/organizations
   * @secure
   */
  createOrganization = (data, params = {}) =>
    this.http.request({
      path: `/api/organizations`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve organization details.
   *
   * @tags Organizations
   * @name GetOrganization
   * @summary Get Organization
   * @request GET:/api/organizations/{organization_id}
   * @secure
   */
  getOrganization = (organizationId, params = {}) =>
    this.http.request({
      path: `/api/organizations/${organizationId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update an organization.
   *
   * @tags Organizations
   * @name UpdateOrganization
   * @summary Update Organization
   * @request PUT:/api/organizations/{organization_id}
   * @secure
   */
  updateOrganization = (organizationId, data, params = {}) =>
    this.http.request({
      path: `/api/organizations/${organizationId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete an organization (soft delete: the organization is marked DELETED and its records, including the immutable audit trail, are kept).
   *
   * @tags Organizations
   * @name DeleteOrganization
   * @summary Delete Organization
   * @request DELETE:/api/organizations/{organization_id}
   * @secure
   */
  deleteOrganization = (organizationId, params = {}) =>
    this.http.request({
      path: `/api/organizations/${organizationId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Get organization settings.
   *
   * @tags Organizations
   * @name GetSettings
   * @summary Get Settings
   * @request GET:/api/organizations/{organization_id}/settings
   * @secure
   */
  getSettings = (organizationId, params = {}) =>
    this.http.request({
      path: `/api/organizations/${organizationId}/settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update organization settings.
   *
   * @tags Organizations
   * @name UpdateSettings
   * @summary Update Settings
   * @request PUT:/api/organizations/{organization_id}/settings
   * @secure
   */
  updateSettings = (organizationId, data, params = {}) =>
    this.http.request({
      path: `/api/organizations/${organizationId}/settings`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Upload, validate X.509 validity dates, and securely store an encrypted certificate.
   *
   * @tags Organizations
   * @name UploadCertificate
   * @summary Upload Certificate
   * @request POST:/api/organizations/{organization_id}/settings/certificates
   * @secure
   */
  uploadCertificate = (organizationId, data, params = {}) =>
    this.http.request({
      path: `/api/organizations/${organizationId}/settings/certificates`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get organization branding.
   *
   * @tags Organizations
   * @name GetBranding
   * @summary Get Branding
   * @request GET:/api/organizations/{organization_id}/branding
   * @secure
   */
  getBranding = (organizationId, params = {}) =>
    this.http.request({
      path: `/api/organizations/${organizationId}/branding`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update organization branding.
   *
   * @tags Organizations
   * @name UpdateBranding
   * @summary Update Branding
   * @request PUT:/api/organizations/{organization_id}/branding
   * @secure
   */
  updateBranding = (organizationId, data, params = {}) =>
    this.http.request({
      path: `/api/organizations/${organizationId}/branding`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve workspace audit log trail for tenant managers and compliance auditors.
   *
   * @tags Organizations
   * @name GetOrganizationAuditLogs
   * @summary Get Organization Workspace Audit Logs
   * @request GET:/api/organizations/{organization_id}/audit-logs
   * @secure
   */
  getOrganizationAuditLogs = (organizationId, query, params = {}) =>
    this.http.request({
      path: `/api/organizations/${organizationId}/audit-logs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Add a member to an organization with strict path and role escalation checks.
   *
   * @tags Organizations
   * @name AddMember
   * @summary Add Member
   * @request POST:/api/organizations/{organization_id}/members
   * @secure
   */
  addMember = (organizationId, data, params = {}) =>
    this.http.request({
      path: `/api/organizations/${organizationId}/members`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List organization members.
   *
   * @tags Organizations
   * @name ListMembers
   * @summary List Members
   * @request GET:/api/organizations/{organization_id}/members
   * @secure
   */
  listMembers = (organizationId, params = {}) =>
    this.http.request({
      path: `/api/organizations/${organizationId}/members`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update organization member details.
   *
   * @tags Organizations
   * @name UpdateMember
   * @summary Update Member
   * @request PUT:/api/organizations/{organization_id}/members/{member_id}
   * @secure
   */
  updateMember = (organizationId, memberId, data, params = {}) =>
    this.http.request({
      path: `/api/organizations/${organizationId}/members/${memberId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Remove a member from an organization.
   *
   * @tags Organizations
   * @name RemoveMember
   * @summary Remove Member
   * @request DELETE:/api/organizations/{organization_id}/members/{member_id}
   * @secure
   */
  removeMember = (organizationId, memberId, params = {}) =>
    this.http.request({
      path: `/api/organizations/${organizationId}/members/${memberId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Preview invitation details by token.
   *
   * @tags Organizations
   * @name PreviewInvitation
   * @summary Preview Invitation
   * @request GET:/api/organizations/preview/{token}
   */
  previewInvitation = (token, params = {}) =>
    this.http.request({
      path: `/api/organizations/preview/${token}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Invite a user to an organization. Requires manager or owner authority.
   *
   * @tags Organizations
   * @name CreateInvitation
   * @summary Create Invitation
   * @request POST:/api/organizations/{organization_id}/invitations
   * @secure
   */
  createInvitation = (organizationId, data, params = {}) =>
    this.http.request({
      path: `/api/organizations/${organizationId}/invitations`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List organization invitations. Requires manager or owner authority.
   *
   * @tags Organizations
   * @name ListInvitations
   * @summary List Invitations
   * @request GET:/api/organizations/{organization_id}/invitations
   * @secure
   */
  listInvitations = (organizationId, params = {}) =>
    this.http.request({
      path: `/api/organizations/${organizationId}/invitations`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Accept an organization invitation.
   *
   * @tags Organizations
   * @name AcceptInvitation
   * @summary Accept Invitation
   * @request POST:/api/organizations/invitations/accept
   * @secure
   */
  acceptInvitation = (data, params = {}) =>
    this.http.request({
      path: `/api/organizations/invitations/accept`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Mint a token the editor passes to the marketing-site iframe so it can preview this org's unpublished landing page across origins.
   *
   * @tags Organizations
   * @name MintLandingPreviewToken
   * @summary Mint a short-lived landing-page preview token
   * @request POST:/api/organizations/{organization_id}/landing-page/preview-token
   * @secure
   */
  mintLandingPreviewToken = (organizationId, params = {}) =>
    this.http.request({
      path: `/api/organizations/${organizationId}/landing-page/preview-token`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get Landing Page.
   *
   * @tags Organizations
   * @name GetLandingPage
   * @summary Get landing page configuration
   * @request GET:/api/organizations/{organization_id}/landing-page
   * @secure
   */
  getLandingPage = (organizationId, params = {}) =>
    this.http.request({
      path: `/api/organizations/${organizationId}/landing-page`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update Landing Page.
   *
   * @tags Organizations
   * @name UpdateLandingPage
   * @summary Update landing page configuration
   * @request PUT:/api/organizations/{organization_id}/landing-page
   * @secure
   */
  updateLandingPage = (organizationId, data, params = {}) =>
    this.http.request({
      path: `/api/organizations/${organizationId}/landing-page`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all information requests for an application.
   *
   * @tags Organizations
   * @name ListInformationRequests
   * @summary List Information Requests
   * @request GET:/api/organizations/{organization_id}/applications/{application_id}/information-requests
   * @secure
   */
  listInformationRequests = (organizationId, applicationId, params = {}) =>
    this.http.request({
      path: `/api/organizations/${organizationId}/applications/${applicationId}/information-requests`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new information request for an applicant.
   *
   * @tags Organizations
   * @name CreateInformationRequest
   * @summary Create Information Request
   * @request POST:/api/organizations/{organization_id}/applications/{application_id}/information-requests
   * @secure
   */
  createInformationRequest = (
    organizationId,
    applicationId,
    data,
    params = {},
  ) =>
    this.http.request({
      path: `/api/organizations/${organizationId}/applications/${applicationId}/information-requests`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get a specific information request.
   *
   * @tags Organizations
   * @name GetInformationRequest
   * @summary Get Information Request
   * @request GET:/api/organizations/{organization_id}/applications/{application_id}/information-requests/{request_id}
   * @secure
   */
  getInformationRequest = (
    organizationId,
    applicationId,
    requestId,
    params = {},
  ) =>
    this.http.request({
      path: `/api/organizations/${organizationId}/applications/${applicationId}/information-requests/${requestId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Accept a submitted information request.
   *
   * @tags Organizations
   * @name AcceptInformationRequest
   * @summary Accept Information Request
   * @request PUT:/api/organizations/{organization_id}/applications/{application_id}/information-requests/{request_id}/accept
   * @secure
   */
  acceptInformationRequest = (
    organizationId,
    applicationId,
    requestId,
    params = {},
  ) =>
    this.http.request({
      path: `/api/organizations/${organizationId}/applications/${applicationId}/information-requests/${requestId}/accept`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Return a submitted information request for revision.
   *
   * @tags Organizations
   * @name ReturnInformationRequest
   * @summary Return Information Request
   * @request PUT:/api/organizations/{organization_id}/applications/{application_id}/information-requests/{request_id}/return
   * @secure
   */
  returnInformationRequest = (
    organizationId,
    applicationId,
    requestId,
    data,
    params = {},
  ) =>
    this.http.request({
      path: `/api/organizations/${organizationId}/applications/${applicationId}/information-requests/${requestId}/return`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
